import type {
  TProjectPermissionMatrixConfig,
  TProjectPermissionRow
} from "components/permissions-matrix/types";
import { EUserRoleName } from "constants/index";

const permissionRows: TProjectPermissionRow[] = [
  {
    id: "submittals_view",
    feature_key: "submittals",
    feature_label: "Submittals",
    action: "View Submittals in Log and Details pages",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "LIMITED",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "LIMITED",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "ALLOW"
  },
  {
    id: "submittals_create_update_delete",
    feature_key: "submittals",
    feature_label: "Submittals",
    action: "Sync, Update and Delete Submittals",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "`NO`",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NO"
  },
  {
    id: "materials_view",
    feature_key: "materials",
    feature_label: "Materials",
    action: "View Materials in Log and Details pages",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "LIMITED",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "LIMITED",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "ALLOW"
  },
  {
    id: "materials_update_comments_attachments",
    feature_key: "materials",
    feature_label: "Materials",
    action: "Add Comments and Attachments",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "ALLOW"
  },
  {
    id: "materials_update_characteristics",
    feature_key: "materials",
    feature_label: "Materials",
    action: "Update Material Characteristics",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "LIMITED",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "materials_update_durations_actual_dates",
    feature_key: "materials",
    feature_label: "Materials",
    action: "Update Durations and Actual Dates",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "NO",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "materials_create_update_delete",
    feature_key: "materials",
    feature_label: "Materials",
    action: "Create, Update and Delete Materials",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "schedules_view",
    feature_key: "schedules",
    feature_label: "Schedules",
    action: "View Project Schedules",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "ALLOW"
  },
  {
    id: "schedules_create_update_links",
    feature_key: "schedules",
    feature_label: "Schedules",
    action: "Create and Update Links",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "schedules_make_active",
    feature_key: "schedules",
    feature_label: "Schedules",
    action: "View Change Impact and make a new version active",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "schedules_import_delete",
    feature_key: "schedules",
    feature_label: "Schedules",
    action: "Import and Delete Project Schedule",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "reports_view_generate",
    feature_key: "reports",
    feature_label: "Reports",
    action: "View and generate reports",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "ALLOW"
  },
  {
    id: "project_settings_view",
    feature_key: "project_settings",
    feature_label: "Project Settings",
    action: "View Project Settings",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  },
  {
    id: "project_settings_add_update",
    feature_key: "project_settings",
    feature_label: "Project Settings",
    action: "Add and Update Project Settings",
    [EUserRoleName[EUserRoleName.gc_project_admin]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_estimator]]: "ALLOW",
    [EUserRoleName[EUserRoleName.gc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_project_admin]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_foreman]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_architect]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_design_engineer]]: "NONE",
    [EUserRoleName[EUserRoleName.gc_sc_owner]]: "NONE"
  }
];

const featureGroupMetaByKey = {
  project_settings: {
    label: "Project Settings",
    tooltip:
      "Includes everything under General Settings, Module Settings, Locations and Integrations."
  },
  submittals: {
    label: "Submittals"
  },
  materials: {
    label: "Materials"
  },
  schedules: {
    label: "Schedules"
  },
  reports: {
    label: "Reports"
  }
};

export const projectPermissionsConfig: TProjectPermissionMatrixConfig = {
  rows: permissionRows,
  featureGroupMetaByKey
};
